/* ============================================================================
   RF Tür-Mechanik v3 — 2026-07-17 — Kategorie-Bäume (Navi + Getriebe)
   DATENGETRIEBEN: Facetten-Werte, deren System-Metaobjekt eine 'kollektion'
   verknüpft hat, werden vom Snippet collection-filters.liquid mit
   data-rf-door="<url>" (am Input) + <a>-Label gerendert. Dieses Skript macht
   daraus die Tür: 1 Auswahl mit Seite → Navigation; Kombination → Filter.
   NEU (v3): Das Snippet rendert zusätzlich <div id="rf-door-config" hidden
   data-rf-pillar data-rf-kategorie> für die AKTUELLE Seite. Daraus ergibt sich
   der Baum (Navigationsgerät ODER Getriebesteuergerät) samt Pillar für das
   0-/Mehrfachauswahl-Routing. Fehlt das Div (z.B. gecachtes v2-HTML), greift
   der Navi-Fallback wie bisher — Navi-Verhalten bleibt identisch.
   BUILTIN-Türen (Marken-GIDs + Hersteller "Harman") gelten NUR im eigenen
   Baum: dieselbe Marken-GID führt im Navi-Baum auf die Navi-Marken-Collection,
   im Getriebe-Baum auf die Getriebe-Marken-Collection. Außerhalb beider Bäume
   feuern BUILTIN-Türen nicht (GID wäre mehrdeutig) — nur data-rf-door-
   Einzeltüren werden dort abgefangen.
   NEUE TÜR = Collection + kategorie am System-Metaobjekt pflegen (kein Code).
   NEUE KATEGORIE = Pillar-Mapping im Snippet + ggf. BUILTIN hier ergänzen.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__rfFacetDoors) return;
  window.__rfFacetDoors = true;

  var KAT_NAVI = 'Navigationsgerät';
  var KAT_GETRIEBE = 'Getriebesteuergerät';
  var NAVI_PILLAR = '/collections/navigationssystem-reparatur';
  var GETRIEBE_PILLAR = '/collections/getriebesteuergeraet-reparatur';
  var P_HER = 'filter.p.m.custom.geraetehersteller';
  var P_MRK = 'filter.p.m.custom.marke';
  var BUILTIN = [
    // Navi-Baum — unverändert zu v2 (gleiche GIDs, gleiche Ziele)
    { k: KAT_NAVI, p: P_HER, v: 'Harman', path: '/collections/mib-navigationsgeraete-harman-reparatur' },
    { k: KAT_NAVI, p: P_MRK, v: 'gid://shopify/Metaobject/45840203999', path: '/collections/vw-navigationsgeraete-reparatur' },
    { k: KAT_NAVI, p: P_MRK, v: 'gid://shopify/Metaobject/45840597215', path: '/collections/audi-navigationsgeraete-reparatur' },
    { k: KAT_NAVI, p: P_MRK, v: 'gid://shopify/Metaobject/45840367839', path: '/collections/skoda-navigationsgeraete-reparatur' },
    { k: KAT_NAVI, p: P_MRK, v: 'gid://shopify/Metaobject/45840662751', path: '/collections/seat-navigationsgeraete-reparatur' },
    { k: KAT_NAVI, p: P_MRK, v: 'gid://shopify/Metaobject/45840531679', path: '/collections/porsche-navigationsgeraete-reparatur' },
    // Getriebe-Baum — GIDs 2026-07-17 read-only gegen Admin API (metaobjects
    // type:"marke") UND gegen die Live-Facette des Getriebe-Pillars verifiziert
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840597215', path: '/collections/audi-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840269535', path: '/collections/ford-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840335071', path: '/collections/mercedes-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840564447', path: '/collections/opel-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840662751', path: '/collections/seat-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840367839', path: '/collections/skoda-getriebesteuergeraet-reparatur' },
    { k: KAT_GETRIEBE, p: P_MRK, v: 'gid://shopify/Metaobject/45840203999', path: '/collections/vw-getriebesteuergeraet-reparatur' }
  ];

  function facetInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[form="FacetsFilterForm"][name^="filter."]')
    );
  }
  // Baum der aktuellen Seite: { pillar, kat } oder null (= passiv außer Einzeltüren).
  // Quelle ist das vom Snippet gerenderte Config-Div; ohne Div (altes/gecachtes
  // Snippet-HTML) greift die v2-kompatible Pfad-Erkennung mit Navi-Default.
  function treeInfo() {
    var el = document.getElementById('rf-door-config');
    if (el) {
      var p = el.getAttribute('data-rf-pillar') || '';
      if (!p) return null;
      return { pillar: p, kat: el.getAttribute('data-rf-kategorie') || '' };
    }
    if (location.pathname === NAVI_PILLAR) return { pillar: NAVI_PILLAR, kat: KAT_NAVI };
    if (location.pathname === GETRIEBE_PILLAR) return { pillar: GETRIEBE_PILLAR, kat: KAT_GETRIEBE };
    for (var i = 0; i < BUILTIN.length; i++) {
      if (BUILTIN[i].path === location.pathname) {
        return BUILTIN[i].k === KAT_GETRIEBE
          ? { pillar: GETRIEBE_PILLAR, kat: KAT_GETRIEBE }
          : { pillar: NAVI_PILLAR, kat: KAT_NAVI };
      }
    }
    // Türseite per data-rf-door, Kategorie im alten HTML unbekannt → Navi (v2-kompatibel)
    if (implicitDoor()) return { pillar: NAVI_PILLAR, kat: KAT_NAVI };
    return null;
  }
  function builtinByPV(p, v, kat) {
    if (!kat) return null; // ohne Baum ist die Marken-GID mehrdeutig → kein Builtin
    for (var i = 0; i < BUILTIN.length; i++) {
      if (BUILTIN[i].k === kat && BUILTIN[i].p === p && BUILTIN[i].v === v) return BUILTIN[i].path;
    }
    return null;
  }
  // Tür, deren Ziel die AKTUELLE Seite ist (für Checked-State + Abwahl)
  function implicitDoor() {
    var inps = facetInputs();
    for (var i = 0; i < inps.length; i++) {
      if (inps[i].getAttribute('data-rf-door') === location.pathname) {
        return { p: inps[i].name, v: inps[i].value };
      }
    }
    for (var j = 0; j < BUILTIN.length; j++) {
      if (BUILTIN[j].path === location.pathname) return { p: BUILTIN[j].p, v: BUILTIN[j].v };
    }
    return null;
  }
  function doorUrlFor(p, v, tree) {
    var inps = facetInputs();
    for (var i = 0; i < inps.length; i++) {
      if (inps[i].name === p && inps[i].value === v) {
        var d = inps[i].getAttribute('data-rf-door');
        if (d) return d;
        break;
      }
    }
    return builtinByPV(p, v, tree && tree.kat);
  }
  function currentSel() {
    var sel = [];
    facetInputs().forEach(function (i) { if (i.checked) sel.push({ p: i.name, v: i.value }); });
    return sel;
  }
  function dedupe(sel) {
    var seen = {}, out = [];
    sel.forEach(function (s) {
      var k = s.p + '|' + s.v;
      if (!seen[k]) { seen[k] = 1; out.push(s); }
    });
    return out;
  }
  function urlFor(sel, tree) {
    if (sel.length === 1) {
      var d = doorUrlFor(sel[0].p, sel[0].v, tree);
      if (d) return d;
    }
    if (!tree || !tree.pillar) return null;
    if (sel.length === 0) return tree.pillar;
    var q = sel.map(function (s) {
      return encodeURIComponent(s.p) + '=' + encodeURIComponent(s.v);
    }).join('&');
    return tree.pillar + '?' + q;
  }

  // Türseite: den impliziten Wert als angehakt anzeigen (auch nach Re-Renders)
  function markImplicit() {
    var here = implicitDoor();
    if (!here) return;
    facetInputs().forEach(function (i) {
      if (i.name === here.p && i.value === here.v && !i.checked) i.checked = true;
    });
  }
  // RF 2026-11-01 (Tim): Auf einer Tür-Seite zeigt Shopify nur die Werte dieser Kollektion, die Facette der Tür wäre eine Sackgasse.
  // Ihre Liste kommt deshalb von der Hauptseite. In Liquid geht das nicht, collections[x].filters ist außerhalb der aktuellen Kollektion leer.
  // Schlägt der Abruf fehl, bleibt die Facette wie sie ist.
  var SIB_TTL = 30 * 60 * 1000;
  var sibVersucht = false;
  function facetList(param) {
    var inps = facetInputs();
    for (var i = 0; i < inps.length; i++) {
      if (inps[i].name === param) return inps[i].closest('.facet-options-list');
    }
    return null;
  }
  function applySiblings(list, html, here) {
    list.setAttribute('data-rf-sib', '1');
    if (!html || html.indexOf(here.v) === -1) return;
    list.innerHTML = html;
    var facet = list.closest('.facet');
    if (facet && list.querySelectorAll('li').length > 10) facet.classList.add('facet-long');
    markImplicit();
  }
  function keepSiblings() {
    var tree = treeInfo();
    var here = implicitDoor();
    if (!tree || !tree.pillar || !here || location.pathname === tree.pillar) return;
    var list = facetList(here.p);
    if (!list || list.getAttribute('data-rf-sib')) return;
    var key = 'rf-sib:' + tree.pillar + ':' + here.p;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key)); } catch (err) { cached = null; }
    if (cached && Date.now() - cached.t < SIB_TTL) { applySiblings(list, cached.html, here); return; }
    if (sibVersucht) return;
    sibVersucht = true;
    fetch(tree.pillar, { credentials: 'same-origin' }).then(function (r) {
      return r.ok ? r.text() : '';
    }).then(function (text) {
      if (!text) return;
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var inp = doc.querySelector('input[form="FacetsFilterForm"][name="' + here.p + '"]');
      var hub = inp && inp.closest('.facet-options-list');
      var html = hub ? hub.innerHTML : '';
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), html: html })); } catch (err) { /* ohne Zwischenspeicher weiter */ }
      var aktuell = facetList(here.p);
      if (aktuell && !aktuell.getAttribute('data-rf-sib')) applySiblings(aktuell, html, here);
    }).catch(function () { /* Facette bleibt wie sie ist */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markImplicit);
    document.addEventListener('DOMContentLoaded', keepSiblings);
  } else {
    markImplicit();
    keepSiblings();
  }
  new MutationObserver(function () { markImplicit(); keepSiblings(); }).observe(document.documentElement, { childList: true, subtree: true });

  // Klick-Interzeption (Capture-Phase, vor Theme-Handlern).
  // Beim click-Event trägt die Checkbox bereits den NEUEN Zustand.
  document.addEventListener('click', function (e) {
    var inp = e.target;
    if (!inp || inp.tagName !== 'INPUT') return;
    if (inp.getAttribute('form') !== 'FacetsFilterForm') return;
    if (!inp.name || inp.name.indexOf('filter.') !== 0) return;

    var tree = treeInfo();
    var here = implicitDoor();
    var next = currentSel().filter(function (s) {
      return !(s.p === inp.name && s.v === inp.value);
    });
    if (inp.checked) next.push({ p: inp.name, v: inp.value });
    // RF 2026-11-01: Ein anderer Wert derselben Facette wechselt auf einer Tür-Seite die Tür, statt mit ihr zu kombinieren.
    if (here && inp.name === here.p && inp.value !== here.v) {
      next = next.filter(function (s) { return !(s.p === here.p && s.v === here.v); });
    } else if (here && !(inp.name === here.p && inp.value === here.v)) {
      next.push({ p: here.p, v: here.v });
    }
    next = dedupe(next);

    // Außerhalb beider Bäume: nur Einzel-Türen per data-Attribut, sonst Theme
    if (!tree && !(next.length === 1 && doorUrlFor(next[0].p, next[0].v, null))) return;

    var target = urlFor(next, tree);
    if (target == null) return;
    var targetPath = target.split('?')[0];
    if (targetPath === location.pathname && !here) return; // Pillar bleibt Pillar → Theme filtert

    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    window.location.assign(target);
  }, true);
})();
